export default __webpack_public_path__ + "static/media/pluriusFull.e5c171d7.svg";